import { RouteRecordRaw } from 'vue-router'

const homeRouter: RouteRecordRaw = {
  path: '/home',
  name: 'home-layout',
  component: () => import('@/layout/home-layout.vue'),
  children: [
    {
      path: '/home',
      name: 'home-page',
      component: () => import('@/views/home/home-page/home-page.vue'),
      meta: { silder: '首页', img: 'home' }
    },
    {
      path: '/home/statistical',
      name: 'statistical-analysis',
      meta: { silder: '统计分析', img: 'Dashboard', auth: 'fpc' },
      children: [
        {
          path: '/home/statistical/output-statistics',
          name: 'output-statistics',
          component: () => import('@/views/home/statistical-analysis/output-statistics/output-statistics.vue'),
          meta: { silder: '销项统计', auth: 'fpc.xxList' }
        },
        {
          path: '/home/statistical/input-statistics',
          name: 'input-statistics',
          component: () => import('@/views/home/statistical-analysis/input-statistics/input-statistics.vue'),
          meta: { silder: '进项统计', auth: 'fpc.jxList' }
        }
      ]
    },
    // {
    //   path: '/home/instrument-panel',
    //   name: 'instrument-panel',
    //   component: () => import('@/views/home/instrument-panel/instrument-panel.vue'),
    //   meta: { silder: '仪表盘', img: 'Dashboard' }
    // },
    {
      path: '/home/firm',
      name: 'home-firm-lists',
      component: () => import('@/views/home/firm-management/firm-management.vue'),
      meta: { auth: 'qygl', silder: '企业管理', img: 'businessmanagement' }
    },
    {
      path: '/home/invoicing',
      name: 'invoicing',
      // component: () => import('@/views/home/invoicing/blue-invoice.vue'),
      meta: { silder: '开票', img: 'Invoicing', auth: 'invoicing' },
      children: [
        {
          path: '/home/invoicing/bill-management',
          name: 'bill-management',
          meta: { silder: '开票信息管理', auth: 'invoiceManagement' },
          children: [
            {
              path: '/home/invoicing/bill-management/items',
              name: 'bill-management-items',
              component: () => import('@/views/home/invoicing/bill-management/items-management/items-management.vue'),
              meta: { silder: '项目信息管理', auth: 'xmxxgl.list' }
            },
            {
              path: '/home/invoicing/bill-management/customer',
              name: 'bill-management-customer',
              component: () =>
                import('@/views/home/invoicing/bill-management/customer-management/customer-management.vue'),
              meta: { silder: '客户信息管理', auth: 'khxxgl.khxxList' }
            },
            {
              path: '/home/invoicing/bill-management/additional',
              name: 'bill-management-additional',
              component: () =>
                import('@/views/home/invoicing/bill-management/additional-management/additional-management.vue'),
              meta: { silder: '附加信息管理', auth: 'fjxxgl.fjxxList' }
            }
          ]
        },
        {
          path: '/home/invoicing/blue',
          name: 'invoicing-blue',
          meta: { silder: '蓝字发票', auth: 'blueInvoice' },
          children: [
            {
              path: '/home/invoicing/blue/single-opener',
              name: 'single-opener',
              component: () => import('@/views/home/invoicing/blue-invoice/single-opener/single-opener.vue'),
              meta: { silder: '单张开具', auth: 'dzkj.list' }
            },
            {
              path: '/home/invoicing/blue/batch-opener',
              name: 'batch-opener',
              component: () => import('@/views/home/invoicing/blue-invoice/batch-opener.vue'),
              meta: { silder: '批量开具', auth: 'plkj.list' }
            },
            {
              path: '/home/invoicing/blue/fast-opener',
              name: 'fast-opener',
              component: () => import('@/views/home/invoicing/blue-invoice/fast-opener/fast-opener.vue'),
              meta: { silder: '快捷开票', auth: 'kjkp.list' }
            }
            // {
            //   path: '/home/invoicing/blue/opened',
            //   name: 'blue-invoice',
            //   component: () => import('@/views/home/invoicing/blue-invoice/blue-invoice.vue'),
            //   meta: { silder: '待开蓝字发票', auth: 'plkj.listLz' }
            // }
          ]
        },
        {
          path: '/home/invoicing/red',
          name: 'invoicing-red',
          meta: { silder: '红字发票', auth: 'hzfpkj' },
          children: [
            {
              path: '/home/invoicing/red/confirm',
              name: 'confirmation-entry',
              component: () => import('@/views/home/invoicing/red-invoice/confirmation-entry.vue'),
              meta: { silder: '红字确认单录入', auth: 'hzfpkj.hclr' }
            },
            {
              path: '/home/invoicing/red/send',
              name: 'send-confirmation',
              component: () => import('@/views/home/invoicing/red-invoice/send-confirmation.vue'),
              meta: { silder: '发出的确认单', auth: 'hzfpkj.list' }
            },
            {
              path: '/home/invoicing/red/received',
              name: 'received-confirmation',
              component: () => import('@/views/home/invoicing/red-invoice/received-confirmation.vue'),
              meta: { silder: '收到的确认单', auth: 'hzfpkj.list' }
            },
            {
              path: '/home/invoicing/red/opened',
              name: 'red-invoice',
              component: () => import('@/views/home/invoicing/red-invoice/red-invoice.vue'),
              meta: { silder: '待开红字发票', auth: 'hzfpkj.dklist' }
            }
            // {
            //   path: '/home/invoicing/red/reocrd',
            //   name: 'red-record',
            //   component: () => import('@/views/home/invoicing/red-invoice/invoice-record.vue'),
            //   meta: { silder: '红字发票记录' }
            // }
          ]
        },
        {
          path: '/home/invoicing/blue/order',
          name: 'order-management',
          component: () => import('@/views/home/invoicing/blue-invoice/order-management/order-management.vue'),
          meta: { silder: '订单管理', auth: '' }
        },
        // {
        //   path: '/home/invoicing/reocrd/flushred',
        //   name: 'record-flushred',
        //   component: () => import('@/views/home/invoicing/invoice-record/flush-red.vue'),
        //   meta: { silder: '蓝票红冲', show: false, noMenu: true }
        // },
        {
          path: '/home/invoicing/reocrd',
          name: 'invoice-record',
          component: () => import('@/views/home/invoicing/invoice-record/invoice-record.vue'),
          meta: { silder: '开票记录', auth: 'kpjl' }
        }
      ]
    },
    {
      path: '/home/use-invoice',
      name: 'use-invoice',
      meta: { silder: '用票', img: 'Tickets', auth: 'useInvoice' },
      children: [
        {
          path: '/home/use-invoice/deduction',
          name: 'deduction-check',
          component: () => import('@/views/home/use-invoice/deduction-check/deduction-check.vue'),
          meta: { silder: '抵扣勾选', auth: 'dkgx' }
        },
        {
          path: '/home/use-invoice/deduction/detail',
          name: 'deduction-check-detail',
          component: () =>
            import('@/views/home/use-invoice/deduction-check/deduction-check-detail/deduction-check-detail.vue'),
          meta: { silder: '抵扣勾选', activeMenu: '/home/use-invoice/deduction', show: false, auth: 'dkgx' }
        },
        {
          path: '/home/use-invoice/deduction/statistics',
          name: 'deduction-check-statistics',
          component: () => import('@/views/home/use-invoice/deduction-check/batch-deduct-statistics.vue'),
          meta: {
            silder: '批量抵扣统计',
            activeMenu: '/home/use-invoice/deduction',
            show: false,
            auth: 'dkgx.dkgxTjqr'
          }
        },
        {
          path: '/home/use-invoice/into-account',
          name: 'into-account',
          component: () => import('@/views/home/use-invoice/into-account/into-account.vue'),
          meta: { silder: '入账勾选', auth: 'fprz' }
        },
        {
          path: '/home/use-invoice/into-account-data',
          name: 'into-account-data',
          component: () => import('@/views/home/use-invoice/into-account/into-account-data.vue'),
          meta: {
            silder: '',
            activeMenu: '/home/use-invoice/into-account',
            show: false,
            noBreadcrumb: true,
            auth: ''
          }
        },
        // {
        //   path: '/home/use-invoice/rule',
        //   name: 'rule-configuration',
        //   component: () => import('@/views/home/use-invoice/rule-configuration/rule-configuration.vue'),
        //   meta: { silder: '用票规则配置', auth: 'ypgzpz' }
        // },
        // {
        //   path: '/home/use-invoice/rule-setting',
        //   name: 'rule-setting',
        //   component: () => import('@/views/home/use-invoice/rule-configuration/rule-setting.vue'),
        //   meta: { silder: '用票规则配置', show: false }
        // }
        {
          path: '/home/use-invoice/tax-refund-check',
          name: 'tax-refund-check',
          component: () => import('@/views/home/use-invoice/tax-refund-check/tax-refund-check.vue'),
          meta: { silder: '退税勾选', auth: '' }
        },
        {
          path: '/home/use-invoice/intelligent-check',
          name: 'intelligent-check',
          component: () => import('@/views/home/use-invoice/intelligent-check/intelligent-check.vue'),
          meta: { silder: '智能勾选', auth: 'dkgx.dkgxZngx' }
        },
        {
          path: '/home/use-invoice/tax-refund-check-detail',
          name: 'tax-refund-check-detail',
          component: () =>
            import('@/views/home/use-invoice/tax-refund-check/tax-refund-check-detail/tax-refund-check-detail.vue'),
          meta: {
            silder: '',
            activeMenu: '/home/use-invoice/tax-refund-check',
            show: false,
            noBreadcrumb: true,
            auth: ''
          }
        }
      ]
    },
    {
      path: '/home/invoice-pool',
      name: 'invoice-pool',
      meta: { silder: '发票池', img: 'Invoicepool', auth: 'fpc' },
      children: [
        {
          path: '/home/invoice-pool/sales-invoice',
          name: 'sales-invoice',
          component: () => import('@/views/home/invoice-pool/sales-invoice/sales-invoice.vue'),
          meta: { silder: '销项发票', auth: 'fpc.xxList' }
        },
        {
          path: '/home/invoice-pool/incoming-invoice',
          name: 'incoming-invoice',
          component: () => import('@/views/home/invoice-pool/incoming-invoice/incoming-invoice.vue'),
          meta: { silder: '进项发票', auth: 'fpc.jxList' }
        },
        {
          path: '/home/invoice-pool/invoices-collect',
          name: 'invoices-collect',
          component: () => import('@/views/home/invoice-pool/invoices-collect/invoices-collect.vue'),
          meta: { silder: '发票归集记录', auth: 'fpgj' }
        },
        {
          path: '/home/invoice-pool/sales-invoice-data',
          name: 'sales-invoice-data',
          component: () => import('@/views/home/invoice-pool/sales-invoice/sales-invoice-data.vue'),
          meta: { show: false, activeMenu: '/home/invoice-pool/sales-invoice', noBreadcrumb: false }
        },
        {
          path: '/home/invoice-pool/incoming-invoice-data',
          name: 'incoming-invoice-data',
          component: () => import('@/views/home/invoice-pool/incoming-invoice/incoming-invoice-data.vue'),
          meta: { show: false, activeMenu: '/home/invoice-pool/incoming-invoice' }
        },
        {
          path: '/home/invoice-pool/invoice-inspection',
          name: 'invoice-inspection',
          component: () => import('@/views/home/invoice-pool/invoice-inspection/invoice-inspection.vue'),
          meta: { silder: '发票查验', auth: '' }
        }
      ]
    },
    {
      path: '/home/blacklist',
      name: 'blacklist',
      component: () => import('@/views/home/blacklist/black-list.vue'),
      meta: { silder: '黑名单', img: 'blacklist', auth: 'hmd.hmdlist' }
    },
    {
      path: '/home/**',
      redirect: '/home',
      meta: { show: false }
    }
  ]
}
export default homeRouter
